import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchBuilding_groupsReorder = z.any()
export type TagsPatchBuilding_groupsReorder = z.infer<typeof tagsPatchBuilding_groupsReorder>

export const bodyPatchBuilding_groupsReorder = z.object({ "municipalityId": z.string().uuid(), "updates": z.array(z.object({ "id": z.string().uuid(), "order": z.number() })) })
export type BodyPatchBuilding_groupsReorder = z.infer<typeof bodyPatchBuilding_groupsReorder>

export const responsePatchBuilding_groupsReorder = z.any()
export type ResponsePatchBuilding_groupsReorder = z.infer<typeof responsePatchBuilding_groupsReorder>

interface IPatchBuilding_groupsReorder extends BaseMethodType {
  tags: TagsPatchBuilding_groupsReorder,
  body: BodyPatchBuilding_groupsReorder,
  response: ResponsePatchBuilding_groupsReorder
}
export const URL = '/building-groups/reorder'
export const validation = {
  patch: {
    tags: tagsPatchBuilding_groupsReorder,
    body: bodyPatchBuilding_groupsReorder,
    response: responsePatchBuilding_groupsReorder
  }
}
export interface Building_groupsReorder extends BaseRouteType {
  patch: IPatchBuilding_groupsReorder
}